module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "smsup"
  }, [_c('div', {
    staticClass: "g-bd-2",
    attrs: {
      "id": "g-bd"
    }
  }, [_c('div', {
    staticClass: "m-info-new"
  }, [_c('p', {
    staticClass: "middle"
  }, [_vm._v("验证手机号：" + _vm._s(_vm.mobile)), (_vm.fromluo) ? _c('span', {
    staticClass: "change",
    on: {
      "click": _vm.changeMobile
    }
  }, [_vm._v("切换手机号")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "note2"
  }, [_c('div', {
    staticClass: "tips middle"
  }, [_vm._v("为了确认您的身份，请用该手机发送短信：")]), _vm._v(" "), _c('div', {
    staticClass: "cnt-box f-cf"
  }, [_c('div', {
    staticClass: "middle2"
  }, [_c('p', {
    staticClass: "cnt1"
  }, [_vm._v("编辑短信："), _c('span', {
    staticClass: "u-light"
  }, [_vm._v(_vm._s(_vm.receiveCode1))])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "cnt2"
  }, [_vm._v("发送至："), _c('span', {
    staticClass: "u-light"
  }, [_vm._v(_vm._s(_vm.receiveCode3))])])])])]), _vm._v(" "), _c('p', {
    staticClass: "upsms-note3 middle"
  }, [_vm._v("系统不会进行短信回复，短信费用由运营商收取。")])]), _vm._v(" "), _c('div', {
    staticClass: "m-btn middle"
  }, [_c('div', {
    staticClass: "u-btn"
  }, [_c('div', {
    staticClass: "u-upload-note"
  }, [_c('a', {
    staticClass: "u-note-2",
    attrs: {
      "href": _vm.smscnt
    },
    on: {
      "click": _vm.gosms
    }
  }, [_vm._v("前往发送短信")])])])]), _vm._v(" "), _c('p', {
    staticClass: "upsms-note3 middle"
  }, [_vm._v("如果“前往发送短信”操作失败，请手动发送短信")]), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_c('div', {
    staticClass: "m-btn m-btn-2"
  }, [_c('urs-button', {
    ref: "submitBtn",
    attrs: {
      "enableTip": "我已发送短信，登录"
    },
    on: {
      "click": _vm.checkSmsUp
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fb5da9f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SmsUp.vue
// module id = 513
// module chunks = 1